module.exports = __webpack_public_path__ + "202408221624/img/4.bc428826.png";